<template>
  <div class="grid-container content-page"> 
  
    <div class="title-page"><h4>Carnet de bord</h4></div>

    <div class="grid-x grid-margin-x">
      <div class="small-12 medium-12 large-4 cell center" >
        <div class="box-edit-avatar">
          <div class="bubble edit-avatar bottom txtleft" :class="{on: currentUser.avatar === 'body-blue eyeAccessory-none eye-want hat-none mouth-bigSmile neck-none nose-none'}"><span>Pense à modifier ton avatar.</span></div>
          <avatar-profil :user="currentUser" class="small" style="margin-bottom: 20px"></avatar-profil>
        </div>
      </div>
    </div>
    
    <if-user can="see_mood">
      <child-tracking />
    </if-user>

    <div class="grid-x grid-margin-x">
      <div class="small-12 medium-12 large-6 cell">
        <div class="box-dot">
          <div class="content txt">
            <title-box color="red" icon-name="fa-gamepad">Jeu Fil Rouge</title-box>
            <div class="txt">
              <p><strong>Le jeu Fil Rouge</strong> est en cours </br> de développement actuellement</p>
              <bouton href="fil_rouge">En savoir plus</bouton> 
            </div> 
          </div> 
        </div> 
      </div>

      <div class="small-12  medium-12 large-6 cell">
        <div class="box-dot">
          <div class="content">
            <title-box color="green" icon-name="fa-users">La Communauté* de {{ childName }}</title-box>
            <div class="content-badges">
              <item-community v-for="user in community" :user="user" class="proche"></item-community>
            </div>
          </div> 
        </div> 
      </div>
    </div>
    <badges-list :for="subaccounts.child" :badges_ids="badges" />
    
  </div>    
</template>

<script>
  import { mapGetters, mapState, mapActions } from 'vuex'
  import chroma from 'chroma-js'
  import { formatDate } from '@/functions'

  import Bouton from '@/components/Bouton'
  import ItemBadge from '@/components/ItemBadge'
  import ItemTeam from '@/components/ItemTeam'
  import ItemCommunity from '@/components/ItemCommunity'
  import ItemNotif from '@/components/ItemNotif'
  import ItemFiche from '@/components/ItemFiche'
  import TitlePage from '@/components/TitlePage'
  import TitleBox from '@/components/TitleBox'
  import TitleFiche from '@/components/TitleFiche'
  import AvatarProfil from '@/components/AvatarProfil'
  import IfUser from '@/components/IfUser'

  import MedicalTeam from './dashboardComponents/MedicalTeam'
  import BadgesList from './dashboardComponents/BadgesList'
  import ChildTracking from './dashboardComponents/ChildTracking'
  import ParentMenu from './dashboardComponents/ParentMenu'
  import EventCalendar from './dashboardComponents/EventCalendar'
  import EventTimeline from './dashboardComponents/EventTimeline'

  export default {
    components: {AvatarProfil, Bouton, ItemBadge, ItemTeam, ItemCommunity, ItemNotif, ItemFiche, TitlePage, TitleFiche, TitleBox, MedicalTeam, BadgesList, ChildTracking, ParentMenu, EventCalendar, EventTimeline, IfUser },
    computed: {
      ...mapState(['subaccounts']),
      ...mapGetters(['completeName', 'childName', 'badges']),
      currentUser() {
        return this.$store.state.me
      },
      community() {
        let subaccounts = this.$store.state.subaccounts
        let relatives = subaccounts.relatives
        if (subaccounts.child) {
          relatives = relatives.concat(subaccounts.child)
        }
        return relatives
      }
    },
    beforeRouteEnter(to, from, next){
      next(vm => {
        if(vm.$store.state.me.account_type === 'relative'){
          next({ name: 'dashboard-' + vm.$store.state.me.account_type });
        } else {
          next();
        }
      })
    },
    methods: {
      ...mapActions(['newAutoEvaluation', 'firstConnexion']),
      formatDate
    }
  }
</script>
